import React from 'react'
import { Card, CardBody, CardHeader, CardHeaderTitle } from '../../../../../../../_metronic/_partials/controls'

function KurbanReportDetailCardAction() {
  return (
    <div>
      <Card >
        <CardHeader title="Aksi">

        </CardHeader>
        <CardBody>
        </CardBody>
      </Card>
    </div>
  )
}

export default KurbanReportDetailCardAction